export default {
  title: "Passionate Riichi, Ultra-Intense Showdown",
  game_title:
    "《雀夢麻雀》是一款全3D超燃的麻將平台，現在就展開你的立直麻將之旅吧！",
  game_title1:
    "你，作為隊長，將率領超能力雀士征戰異世界麻將大賽，爭奪最強戰隊的榮耀。",
  header: {
    Menu: ["主頁", "人物介紹", "關注我們"],
  },
  role_title: "人物介紹",
  rolt: [
    {
      name: "瑪格蕾",
      desc: "純情三無女僕高難度舞蹈挑戰者",
    },
    { name: "原悠圓", desc: "元氣麻將少女章魚燒消滅大師" },
    { name: "洛琪拉", desc: "超人氣魔術師小心被她當道具" },
    { name: "蘭若", desc: "神秘麻將館主特技乃反彈琵琶" },
    { name: "赫墨", desc: "退役電競選手對熱愛全力以赴" },
    { name: "? ?", desc: "? ? ? ? ? ? ? ?" },
  ],
  "people": {
    "names": ["瑪格蕾", "原悠圓", "洛琪拉", "蘭若", "赫墨", "霧島綾月","花椒","塞莉雅","艾薇","樂盈","????","????"],
    "descs": [
      "純情三無女僕<br/>高難度舞蹈挑戰者",
      "元氣麻將少女<br/>章魚燒消滅大師",
      "超人氣魔術師<br/>小心被她當道具",
      "神秘麻將館主<br/>特技乃反彈琵琶",
      "退役電競選手<br/>對熱愛全力以赴",
      "上古神社巫女<br/>與君續寫未了緣",
      "川味食府大廚<br/>心急吃不了熱豆腐",
      "自戀賞金魔女<br/>記得五星好評哦",
      "天然系聖樹精靈<br/>酷愛洗澡身體好",
      "佛系武術新星<br/>擼貓喝茶甩靚牌",
      "? ? ? ? ? ? ?<br/>? ? ?",
      "? ? ? ? ? ? ?<br/>? ? ?",
    ]
  },
  "footer_list":['服務條款', '隱私政策']
};
